<template>
   <div class="container">
       <div class="container-gp" v-if="projectDict" >
            <div class="title"><span>项目挂牌</span><span @click="$router.push('/quetaHome')">更多</span></div>
            <div class="list" v-for="(item,index) in gpList" :key="index" v-if="index < 4" @click="$router.push({ path:'/quetaDetail',query:{ id:item.id } })">
                <img :src="item.pictureUrl[0]" width="248" height="160"> 
                <div class="desc">
                    <h3 class="nameClass">{{ item.projectName }}</h3> 
                    <p>类别：{{ item.projectCategoryName }}</p> 
                    <!-- <p>性质：{{ $utils.getVal(projectDict.bg_project_nature,item.projectNature) }}</p>  -->
                    <p>地区：{{ item.cityName + item.countyName }}</p> 
                    <p>价格：{{ item.quotationPrice }}万</p> 
                    <p class="perTime">时间：{{ item.entrustTime }}   <span>摘牌</span></p>
                </div>
            </div>    
       </div>   
       <div class="container-jingjia">
            <div class="title"><span>项目竞价</span><span @click="$router.push('/biddingHome')">更多</span></div>
            <div class="list" v-for="(item,index) in jList" :key="index" v-if="index < 4" @click="$router.push({ path:'/biddingDetail',query:{ id:item.id } })">
                <img  :src="item.pictureUrl[0]" alt="" width="100%" style="height: 175px;"> 
                <p class="nameClass">
                    <a-tooltip>
                        <template slot="title">
                           项目名称：{{ item.projectName }}
                        </template>
                           项目名称：{{ item.projectName }}
                    </a-tooltip>
                </p>
                <p>类别：{{ item.projectCategoryName }}</p> 
                <!-- <p>性质：{{ item.projectNature }}</p>  -->
                <p>地区：{{ item.cityName + item.countyName }}</p> 
                <p>起拍价：{{ item.biddingPrice }}万</p> 
                <p>加价幅度：{{ item.biddingUp }}元</p> 
                <p>状态：{{ item.biddingStateName }}</p> 
                <p class="perTime">时间：{{ item.createTime }}   <span data-v-5b2acc48="" class="point">去看看</span></p>
            </div>
       </div>   
   </div>    
</template>
<script>
export default {
    data(){
        return{
            gpList:[],
            jList:[],
            projectDict:''
        } 
    },
    created(){
        //获取字典
        this.$https.get('/portal/projectDict/list').then(res=>{
                if(res.code == 200){
                    this.projectDict = res.rows[0];
                }else{
                     this.$message.info(res.msg)
                }
        })
        this.getBaseInfo();
        this.getProjectBiddingInfo();
    },
    methods:{
        getBaseInfo(){
            this.$https.get('/portal/index/getProjectQuotationInfo').then(res=>{
                 if(res.code == 200){
                      res.rows.forEach(item=>{
                          item.pictureUrl = item.pictureUrl.split(',');
                      })
                      this.gpList = res.rows;
                 }
            })
        },
        getProjectBiddingInfo(){
           this.$https.get('/portal/index/getProjectBiddingInfo').then(res=>{
                 if(res.code == 200){
                      res.rows.forEach(item=>{
                          if(item.pictureUrl){
                             item.pictureUrl = item.pictureUrl.split(',');
                          }
                      })
                      this.jList = res.rows;
                 }
            })
        }
    }
}
</script>

<style lang="less">
.container{
    display: flex;
    justify-content: space-between;
    margin-top:20px;
    .nameClass{
        white-space:nowrap; 
        overflow:hidden; 
        text-overflow:ellipsis; 
    }
    .container-gp{
        background: #fff;
        width:640px;
        padding: 10px 0;
        .list{
            border: 1px solid #dcdcdc;
            padding: 10px 15px;
            margin: 10px;
            overflow: hidden;
            cursor: pointer;
            display: flex;
            .desc{
                width: 57%;
                padding-left: 30px;
                box-sizing: border-box;
                h3{
                    color: #303030;
                    font-size: 20px;
                    margin-bottom: 10px;
                    font-weight: bold;
                }
                p{
                    line-height: 25px;
                    color: #737373;
                    font-size: 15px;
                    margin-bottom: 0;
                }
                .perTime{
                    span{
                        float: right;
                        background-color: skyblue;
                        color: #fff;
                        padding: 0 10px;
                        cursor: pointer;
                    }
                }
            }
        }
    }
    .container-jingjia{
        background: #fff; 
        width:640px;
        padding: 10px 0;
        .title{
            margin-bottom:5px;
            span{
                &:nth-of-type(1){
                    color: #eea75e;
                }
            }
        }
        .list{
            border: 1px solid #dcdcdc;
            padding: 6px 10px;
            margin: 5px 10px;
            overflow: hidden;
            cursor: pointer;
            width: 300px;
            float: left;
            h3{
                color: #303030;
                font-size: 20px;
                margin-bottom: 10px;
                font-weight: bold;
            }
            p{
                line-height: 24px;
                color: #737373;
                font-size: 15px;
                margin-bottom: 0;
            }
            .perTime{
                span{
                    float: right;
                    background-color: skyblue;
                    color: #fff;
                    padding: 0 10px;
                    cursor: pointer;
                }
            }
        }
    }
    .title{
            padding:0 20px;
            display: flex;
            justify-content: space-between;
            span{
                line-height: 32px;
                padding:5px 0;
                &:nth-of-type(1){
                    font-weight: 700;
                    font-size: 22px;
                    color: #468be5;
                }
                &:nth-of-type(2){
                    font-weight: 700;
                    font-size: 14px;
                    cursor: pointer;
                }
            }
        }
}
</style>